import { memo, useContext, useMemo } from 'react';
import Link from 'next/link';

import AppContext, { IAppContext } from '~/contexts/AppContext';

import type { BlogLinkProps } from './types';

function BlogLink({ href, children, ...rest }: BlogLinkProps) {
  const { baseTagHref } = useContext<IAppContext>(AppContext);
  const innerLink = href.charAt(0) === '/';

  const blogHref = useMemo(
    () => (baseTagHref && innerLink ? href.slice(1) : href),
    [baseTagHref, innerLink, href],
  );

  return (
    <Link href={blogHref} {...rest}>
      {children}
    </Link>
  );
}

export default memo(BlogLink);
